cockpitApp.directive('extraCard', function() {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/element/sidenav/extras/extra-card'
  };
});
